import {Controller} from "../controller";
import {DirectosWebFrontendRequest} from "services-comun-ed/modules/services/directos/frontend-web";
import dominio from "services-comun-ed/modules/portal/ed";
import {EBanner} from "services-comun-ed/modules/portal/publicidad";
import {IComentario, IComentarioD} from "services-comun-ed/modules/services/directos/interface";
import {PublicidadController} from "./publicidad";
import {RecursosController} from "./recursos";
import {CompeticionesWebFrontendRequest} from "services-comun-ed/modules/services/competiciones/frontend-web";

declare global{
    interface Window {
        twttr: any;
    }
}

export class DirectoController extends Controller {
    /* STATIC */
    public static override async build(): Promise<void> {

        const form = document.querySelector(".contenedor-directo") as HTMLFormElement|null;
        if (form!=null) {
            new this(form);
        }
    }

    /* INSTANCE */
    private readonly directoId: number|null;
    private contenedorDirecto: HTMLElement|null;
    private actualizarButton: HTMLButtonElement|null;
    private cargarMasButton: HTMLButtonElement|null;
    private marcadorPartido: HTMLElement|null;
    private device: string;

    private constructor(private readonly form: HTMLFormElement) {
        super();

        this.contenedorDirecto = this.form.querySelector(".narracion-directo");

        this.device = this.contenedorDirecto?.getAttribute('data-device')??'mv';
        this.actualizarButton = this.form.querySelector(".actualizar-directo");
        this.cargarMasButton = this.form.querySelector(".cargar-mas");
        this.marcadorPartido = this.form.previousElementSibling?.classList.contains('marcador-noticia') ? this.form.previousElementSibling as HTMLElement : null;

        const dataDirecto = this.contenedorDirecto?.getAttribute('data-directo');
            this.directoId = dataDirecto ?+dataDirecto : null;

        if(this.directoId && this.directoId>0 && this.contenedorDirecto){
            if (this.actualizarButton) {
                this.actualizarButton.onclick = async () => {
                    await this.actualizarDirecto();

                    if(this.marcadorPartido){
                        await this.actualizarMarcador()
                    }
                }
            }

            if (this.cargarMasButton) {
                this.cargarMasButton.onclick = async () => {
                    await this.cargarMasComentarios()
                }
            }
        }
    }

    private async actualizarDirecto() {

        if(this.contenedorDirecto) {
            let ultimaEntrada = this.contenedorDirecto?.lastElementChild as HTMLElement;

            // Si la ultima entrada es publicidad, seleccionamos el elemento anterior
            if(ultimaEntrada.classList.contains('publicidad')){
                ultimaEntrada = ultimaEntrada.previousElementSibling as HTMLElement
            }
            const ultimaEntradaId = ultimaEntrada?.getAttribute('data-comentario');

            if(ultimaEntradaId && this.directoId){
                await DirectosWebFrontendRequest.actualizarComentarios(this.directoId, +ultimaEntradaId).then(async directo => {

                    const plantilla = require(`www-templates/pug/contenido/noticia/directo.pug`);

                    const ad_inline_avail: string[] = [EBanner.directo1, EBanner.directo2, EBanner.directo3, EBanner.directo4, EBanner.directo5]


                    let directoHTML = (await new DOMParser().parseFromString(plantilla({
                        dominio: dominio.get(dominio.WWW),
                        directo: {
                            ...directo,
                            masComentarios: this.cargarMasButton?.classList.contains('disabled')??false,
                            indicesPublicidad: this.getIndicesPublicidad(directo.comentarios,ad_inline_avail.length, this.device=='pc'?900:600, this.device=='pc'?600:50),
                            adInlineAvail: ad_inline_avail,
                        }
                    }), 'text/html')).body.firstChild as HTMLElement;

                    if(this.contenedorDirecto) {
                        this.contenedorDirecto.innerHTML = '';
                        const adNodes: HTMLElement[] = [];
                        const resetNodes: string[] = [];
                        Array.from(directoHTML.querySelector('.narracion-directo')?.children ?? []).map(entradaHtml => {
                            if (this.contenedorDirecto) {
                                const entrada = entradaHtml as HTMLElement;
                                this.contenedorDirecto.appendChild(entrada);
                                if (entrada.id.includes("publicidad")) {
                                    adNodes.push(entrada);
                                    resetNodes.push(entrada.id);
                                }
                            }
                        });
                        PublicidadController.reset("directo", adNodes, resetNodes);
                        for (let instance of RecursosController.instances) {
                            instance.forceResources(this.contenedorDirecto);
                        }
                    }
                })

            }
        }
    }

    private async actualizarMarcador() {
        const partidoId = this.marcadorPartido?.getAttribute('data-partido');

        if(partidoId) {
            await CompeticionesWebFrontendRequest.partido(+partidoId).then(partido => {

                // Actualizacion marcador
                const resultado = this.marcadorPartido?.querySelector('.marcador');
                if(resultado){
                    resultado.innerHTML =`${partido.local.goles??''} - ${partido.visitante.goles??''}`;
                }

                // Actualización estado del partido
                const estadoPartido = this.marcadorPartido?.querySelector('.estado-partido');
                if(estadoPartido){
                    estadoPartido.innerHTML = partido.estado.split('').map(l => {
                        return l.toUpperCase()===l?` ${l}`:l
                    }).join('');
                }
            })
        }
    }

    private async cargarMasComentarios() {

        if(this.contenedorDirecto && !this.contenedorDirecto.classList.contains('disabled')) {
            const ultimaEntrada = this.contenedorDirecto?.lastElementChild as HTMLElement;
            const ultimaEntradaId = ultimaEntrada?.getAttribute('data-comentario');
            if(ultimaEntradaId && this.directoId){
                await DirectosWebFrontendRequest.getComentariosAnteriores(this.directoId, +ultimaEntradaId, 15).then(async comentarios => {
                    const plantilla = require(`www-templates/pug/contenido/noticia/entradaDirecto.pug`);
                    let entradasHTML = await Promise.all(comentarios.map(async comentario => {
                        const parametros = {dominio: dominio.get(dominio.WWW), comentario}
                        return await new DOMParser().parseFromString(plantilla(parametros), 'text/html').body.firstChild as HTMLElement;
                    }));


                    if (this.contenedorDirecto) {

                        let ad_inline_avail: string[] = [EBanner.directo1, EBanner.directo2, EBanner.directo3, EBanner.directo4, EBanner.directo5];
                        let banners = Array.from(this.contenedorDirecto.querySelectorAll('.publicidad')??[])

                        // Eliminar banners ya instanciados
                        ad_inline_avail = ad_inline_avail.filter( ad_avail => {
                            return !banners.map(x => x.id.replace('publicidad-','')).includes(ad_avail)
                        })

                        let entrada = banners.pop();
                        let indicesPublicidad: number[] = []
                        if(entrada){
                            let longitud = 0;
                            do {
                                entrada = entrada.nextElementSibling??undefined;
                                longitud+= +(entrada?.getAttribute('data-longitud')??0);
                            }while (entrada?.getAttribute('data-longitud'));

                            const tamanioPrimerBloque = (this.device=='pc'?600:50)-longitud;
                            indicesPublicidad = this.getIndicesPublicidad(comentarios, ad_inline_avail.length, this.device=='pc'?900:600, Math.max(tamanioPrimerBloque, 0))
                        }

                        let key_publi = 0
                        const adNodes: HTMLElement[] = [];
                        const resetNodes: string[] = [];
                        entradasHTML.map((entradaHtml, key:number) => {
                            if (this.contenedorDirecto) {
                                this.contenedorDirecto.appendChild(entradaHtml)
                                if(indicesPublicidad.includes(key)){

                                    const publiHtml = document.createElement('aside');
                                    publiHtml.className = 'publicidad';
                                    publiHtml.id = `publicidad-${ad_inline_avail[key_publi]}`
                                    publiHtml.classList.add('publicidad');

                                    const edp = document.createElement('div');
                                    edp.classList.add('edp');
                                    edp.id = ad_inline_avail[key_publi];
                                    publiHtml.appendChild(edp);

                                    this.contenedorDirecto.appendChild(publiHtml);

                                    if (ad_inline_avail[key_publi] !== undefined) {
                                        adNodes.push(publiHtml);
                                        resetNodes.push(`publicidad-${ad_inline_avail[key_publi]}`);
                                    }

                                    key_publi++;
                                }
                            }
                        });
                        PublicidadController.reset("directo", adNodes, resetNodes);
                        for (let instance of RecursosController.instances) {
                            instance.forceResources(this.contenedorDirecto);
                        }
                    }

                    if(entradasHTML.length < 10 && !!this.cargarMasButton){
                        this.cargarMasButton.classList.add('disabled')
                    }
                })
            }
        }
    }

    /**
     *
     * @param comentarios
     * @param num_banners indica el número de banners que debe haber en la noticia
     * @param tamano_bloque indica el tamaño mínimo que tiene un bloque
     * @param tamano_primer_bloque indica el tamaño que tiene el primer bloque hasta la publicidad
     * @protected
     */
    public getIndicesPublicidad(comentarios: IComentario[]|IComentarioD[], num_banners: number, tamano_bloque: number, tamano_primer_bloque?: number): number[] {

        const indices = [];
        let sumPesos = 0;
        for(let i in comentarios){
            const comentario = comentarios[i];
            sumPesos+=comentario.longitud;
            // console.log(sumPesos, (indices.length==0?(tamano_primer_bloque??tamano_bloque):tamano_bloque), sumPesos>=(indices.length==0?(tamano_primer_bloque??tamano_bloque):tamano_bloque))
            if(sumPesos>=(indices.length==0?(tamano_primer_bloque??tamano_bloque):tamano_bloque) && +i<(comentarios.length-1)){
                indices.push(+i);
                sumPesos = 0;
                if(indices.length>=num_banners){
                    break;
                }
            }
        }

        return indices;
    }

}
